import { render, staticRenderFns } from "./AvisoSinGuardar.vue?vue&type=template&id=526cf39c"
import script from "./AvisoSinGuardar.vue?vue&type=script&lang=ts"
export * from "./AvisoSinGuardar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports